import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { Container } from '../../Container';
import { SectionMain } from './SectionMain';
import { SectionSide } from './SectionSide';

import './array-sections.css';

const getSectionClassName = (item, datas) => {
    return classNames('section', {
        'whole': item.wholeBackground,
        'no-sides': !item.sideBlogs || item.sideBlogs.length === 0,
        'no-main': !item.mainBlogs || item.mainBlogs.length === 0,
        'no-main-videos': !item.mainVideos || item.mainVideos.length === 0,
        'no-side-videos': !item.sideVideos || item.sideVideos.length === 0,
        'no-datas': !datas || datas.length === 0,
        'has-datas': datas && datas.length > 0
    });
};

export const ArraySections = ({ landingSections, searchQuery, toCamelCase, datas }) => {
    const [language, setLanguage] = useState('English');
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const filtered = datas.filter(post => {
            const matchesLanguage = language === 'English' 
                ? post.languagePreference === 'English' 
                : post.languagePreference !== 'English';
            
            const matchesSearchQuery = post.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
                (post.excerpt?.raw && post.excerpt.raw.toLowerCase().includes(searchQuery.toLowerCase()));
            
            return matchesLanguage && matchesSearchQuery;
        });

        setFilteredData(filtered);
    }, [language, searchQuery, datas]);

    const handleLanguageChange = (selectedLanguage) => {
        setLanguage(selectedLanguage);
    };

    const filteredSections = landingSections.map(section => {
        const filteredMainBlogs = section.mainBlogs?.filter(blog => 
            (blog.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
            (blog.excerpt?.raw && blog.excerpt.raw.toLowerCase().includes(searchQuery.toLowerCase()))) && 
            (language === 'English' ? blog.languagePreference === 'English' : blog.languagePreference !== 'English')
        );
    
        const filteredMainVideos = section.mainVideos?.filter(blog => 
            blog.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
            (blog.excerpt?.raw && blog.excerpt.raw.toLowerCase().includes(searchQuery.toLowerCase()))
        );
    
        // const filteredSideBlogs = section.sideBlogs?.filter(blog => 
        //     (blog.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
        //     (blog.excerpt?.raw && blog.excerpt.raw.toLowerCase().includes(searchQuery.toLowerCase()))) && 
        //     (language === 'English' ? blog.languagePreference === 'English' : blog.languagePreference !== 'English')
        // );
        const filteredSideBlogs = section.sideBlogs
        ?.filter(blog => 
            (blog.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
            (blog.excerpt?.raw && blog.excerpt.raw.toLowerCase().includes(searchQuery.toLowerCase()))) && 
            (language === 'English' ? blog.languagePreference === 'English' : blog.languagePreference !== 'English')
        )
        .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate)); // Sorting here

        const filteredSideVideos = section.sideVideos?.filter(blog => 
            blog.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
            (blog.excerpt?.raw && blog.excerpt.raw.toLowerCase().includes(searchQuery.toLowerCase()))
        );
    
        return {
            ...section,
            mainBlogs: filteredMainBlogs,
            mainVideos: filteredMainVideos,
            sideBlogs: filteredSideBlogs,
            sideVideos: filteredSideVideos
        };
    });

    const [visibleItems, setVisibleItems] = useState(
        filteredSections.map(section => section.mainMaxPostsOnFirstLoad || 4)
    );
    const [sideVisibleItems, setSideVisibleItems] = useState(
        filteredSections.map(section => section.maxPostsOnFirstLoad || 4)
    );
    const [visibleVideoItems, setVisibleVideoItems] = useState(
        filteredSections.map(section => section.mainMaxPostsOnFirstLoad || 4)
    );
    const [sideVisibleVideoItems, setSideVisibleVideoItems] = useState(
        filteredSections.map(section => section.maxPostsOnFirstLoad || 4)
    );
    const [visibleAllBlogItems, setVisibleAllBlogItems] = useState(
        filteredSections.map(section => section.mainMaxPostsOnFirstLoad || 4)
    );

    const loadMore = (index) => {
        setVisibleItems(prevVisibleItems => {
            const newVisibleItems = [...prevVisibleItems];
            newVisibleItems[index] += 6;
            return newVisibleItems;
        });
        setSideVisibleItems(prevSideVisibleItems => {
            const newSideVisibleItems = [...prevSideVisibleItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
    };

    const sideLoadMore = (index) => {
        setSideVisibleItems(prevSideVisibleItems => {
            const newSideVisibleItems = [...prevSideVisibleItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
        setVisibleItems(prevVisibleItems => {
            const newVisibleItems = [...prevVisibleItems];
            newVisibleItems[index] += 6;
            return newVisibleItems;
        });
        setVisibleAllBlogItems(visibleAllBlogItems => {
            const newSideVisibleItems = [...visibleAllBlogItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
    };

    const loadMoreVideos = (index) => {
        setVisibleVideoItems(prevVisibleVideoItems => {
            const newVisibleItems = [...prevVisibleVideoItems];
            newVisibleItems[index] += 6;
            return newVisibleItems;
        });
        setSideVisibleVideoItems(prevSideVisibleVideoItems => {
            const newSideVisibleItems = [...prevSideVisibleVideoItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
    };

    const sideLoadMoreVideos = (index) => {
        setSideVisibleVideoItems(prevSideVisibleVideoItems => {
            const newSideVisibleItems = [...prevSideVisibleVideoItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
        setVisibleVideoItems(prevVisibleVideoItems => {
            const newVisibleItems = [...prevVisibleVideoItems];
            newVisibleItems[index] += 6;
            return newVisibleItems;
        });
    };

    const mainAllLoadMore = (index) => {
        setSideVisibleItems(prevSideVisibleItems => {
            const newSideVisibleItems = [...prevSideVisibleItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
        setVisibleAllBlogItems(visibleAllBlogItems => {
            const newSideVisibleItems = [...visibleAllBlogItems];
            newSideVisibleItems[index] += 6;
            return newSideVisibleItems;
        });
    };
    
    const allSectionsEmpty = filteredSections.every(section => 
        section.mainBlogs?.length === 0 && 
        section.sideBlogs?.length === 0 && 
        section.mainVideos?.length === 0 && 
        section.sideVideos?.length === 0
    );

    return (
        <div className='array-sections'>
            {allSectionsEmpty ? (
                <div className='flex justify-center bold' style={{ padding: '200px 15px',backgroundImage: `url("https://images.ctfassets.net/vhts96p7twn6/4m9hXPHbY1z0WhoMyMlr3H/0272d8dcd6adfdfd92207500ced2e8ee/pg-bk.jpg")` }}>No posts available with that text!</div>
            ) : (
                filteredSections.map((item, index) => {
                    if (
                        (item.mainBlogs?.length === 0 || !item.mainBlogs) &&
                        (item.sideBlogs?.length === 0 || !item.sideBlogs) &&
                        (item.mainVideos?.length === 0 || !item.mainVideos) &&
                        (item.sideVideos?.length === 0 || !item.sideVideos) &&
                        (datas.length === 0 || !datas)
                    ) return null;
                    return (
                        <div 
                            key={index} 
                            id={`${toCamelCase(item.title)}`} 
                            className={getSectionClassName(item, filteredData)}
                            style={{ 
                                backgroundImage: item.wholeBackground ? `url(${item.backgroundImage.gatsbyImageData.images.fallback.src})` : 'none', 
                                backgroundRepeat: 'no-repeat', 
                                backgroundSize: 'cover' 
                            }}
                        >

                            {!item.wholeBackground && (
                                <div className='grid col-6-3 col-1-md gap-10'>
                                    <div className='block'>
                                        <Container>
                                            <h3 className='text-left mt-0 title'>{item.title}</h3>
                                        </Container>
                                    </div>
                                    <div></div>
                                </div>
                            )}
                            <div className={`relative grid col-1-md gap-10${item.sideBlogPosition === 'Left' ? ' col-3-8 col-5-6-lg' : ' col-8-3 col-6-5-lg'} ${item.sideBlogPosition.toLowerCase()} lists`} style={{ backgroundImage: !item.wholeBackground ? `url(${item.backgroundImage.gatsbyImageData.images.fallback.src})` : 'none', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                                <SectionMain
                                    item={item}
                                    index={index}
                                    language={language}
                                    handleLanguageChange={handleLanguageChange}
                                    filteredData={filteredData}
                                    visibleItems={visibleItems}
                                    visibleAllBlogItems={visibleAllBlogItems}
                                    visibleVideoItems={visibleVideoItems}
                                    loadMoreVideos={loadMoreVideos}
                                    datas={datas}
                                    mainAllLoadMore={mainAllLoadMore}
                                    loadMore={loadMore}
                                />
                                <SectionSide
                                    item={item}
                                    index={index}
                                    sideVisibleItems={sideVisibleItems}
                                    sideVisibleVideoItems={sideVisibleVideoItems}
                                    sideLoadMoreVideos={sideLoadMoreVideos}
                                    sideLoadMore={sideLoadMore}
                                />
                            </div>
                        </div>
                    )
                })
            )}
        </div>
    );
};


